import { render, staticRenderFns } from "./Pasien.vue?vue&type=template&id=d8996e56&scoped=true&"
import script from "./Pasien.vue?vue&type=script&lang=js&"
export * from "./Pasien.vue?vue&type=script&lang=js&"
import style0 from "./Pasien.vue?vue&type=style&index=0&id=d8996e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8996e56",
  null
  
)

export default component.exports